import React from "react";
import "./Product_overview.css";
import parse from "html-react-parser";

function Product_overview({ product }) {
  const hasContent = (html) => {
    if (!html) return false;

    const cleaned = html
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return cleaned.length > 0;
  };

  return (
    <section className="Product_overview mt-5">
      <div className="row">
        <div className="col-12">
          {product?.advantages_status && hasContent(product?.advantages) && (
            <div className="overview_section">
              <h3 className="heading_text">Additional Information</h3>

              <div className="overview_body">{parse(product.advantages)}</div>
            </div>
          )}

          <hr/>

          {product?.composition_status && hasContent(product?.composition) && (
            <div className="overview_section">
              <h3 className="heading_text">Size Chart</h3>

              <div className="overview_body">{parse(product.composition)}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Product_overview;
